import React, { forwardRef, ReactNode, Ref } from 'react';
import {
  GDSStyleObject,
  TextAction,
  styled,
} from '@leagueplatform/genesis-core';
import { normalizeInternalUrl } from '@leagueplatform/web-common';
import { InternalOrExternalLinkButton } from '@leagueplatform/web-common-components';

export type ConditionalLinkRendererProps = {
  children: ReactNode;
  url?: string;
  onClick?: (e: React.MouseEvent) => void;
  css?: GDSStyleObject;
  disableDefaultOnClick?: boolean;
};

const StyledTextAction = styled(TextAction, {
  '&&': {
    all: 'inherit',
    cursor: 'pointer',
  },
});

export const ConditionalLinkRenderer = forwardRef(
  (
    {
      children,
      url,
      onClick = () => {},
      css,
      disableDefaultOnClick,
      ...linkProps
    }: ConditionalLinkRendererProps,
    ref: Ref<HTMLAnchorElement>,
  ) => {
    const href = normalizeInternalUrl(url);

    if (url)
      return (
        <InternalOrExternalLinkButton
          baseComponent={StyledTextAction}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            onClick(e);
          }}
          ref={ref}
          href={href}
          disableDefaultOnClick={disableDefaultOnClick}
          css={css}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...linkProps}
        >
          {children}
        </InternalOrExternalLinkButton>
      );
    return <span>{children}</span>;
  },
);
